import { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { getRolePanelPath } from '@/features/auth/roleRoutes';
import '../auth.css';

const roleLabels = {
  customer: 'مشتری',
  vendor: 'فروشنده',
  irancharsouq_admin: 'مدیر ایران چارسوق',
  super_admin: 'مدیر ارشد',
  inspector: 'بازرس',
  company: 'شرکت',
};

export default function SelectRolePage() {
  const { roles, selectRole, loading } = useAuth();
  const navigate = useNavigate();
  const [selectedRole, setSelectedRole] = useState(null);
  const [error, setError] = useState('');

  if (!loading && roles.length === 0) {
    return <Navigate to="/login" replace />;
  }

  const handleSelect = async (role) => {
    const roleType = role.type ?? role.role;
    setSelectedRole(roleType);
    setError('');

    try {
      const result = await selectRole(roleType);
      const panelPath =
        getRolePanelPath(roleType) || result.redirectTo || role.panel_url || '/';
      navigate(panelPath, { replace: true });
    } catch (err) {
      setSelectedRole(null);
      setError(err?.message || 'انتخاب نقش ناموفق بود');
    }
  };

  return (
      <section className="role-selection-page container">
        <div className="role-selection-card card">
          <h1 className="section-title">انتخاب نقش کاربری</h1>
          <p className="section-subtitle">
            برای ادامه، پنل موردنظر خود را انتخاب کنید.
          </p>

          {error && <div className="error-message">{error}</div>}

          <div className="role-selection-list">
            {roles.map((role) => {
              const roleType = role.type ?? role.role;
              const isSelected = selectedRole === roleType;

              return (
                  <button
                      key={role.role_id ?? role.id ?? roleType}
                      type="button"
                      className={`role-selection-option ${isSelected ? 'selected' : ''}`}
                      onClick={() => handleSelect(role)}
                      disabled={Boolean(selectedRole)}
                  >
                <span className="role-selection-option-content">
                  <strong>
                    {roleType === 'vendor' && role.is_direct_to_consumer
                      ? 'کارخانه'
                      : roleLabels[roleType] || role.label || roleType}
                  </strong>
                  {role.is_verified === false && (
                      <small>در انتظار تأیید</small>
                  )}
                </span>
                    <span className="role-selection-arrow">انتخاب</span>
                  </button>
              );
            })}
          </div>
        </div>
      </section>
  );
}